import MainPracticeScenario from './MainPracticeScenario';
import { constants, Globals } from '../../../../misc/helpers';
import Tools from '../../../../core/Misc/Tools';
import { ScenarioSceneType } from '../../../../misc/BleedingControlScenario';

export default class MainPracticeScenarioSteps13And14And15 {
	private numberOfTightens = 0;
	constructor(private mainScenario: MainPracticeScenario, private onDone: () => void, public showFailedAar: () => void) {
	}

	start() {
		this.step1TwistRod();
	}

	private step1TwistRod() {
		var context = this;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});

		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to twist the rod?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps13And14And15.step1TwistRod', () => context.step1TwistRodYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step1TwistRodNo()
			}
		});
	}

	private step1TwistRodYes() {
		this.mainScenario.aarTwistScondTourniqueteRod = true;
		if(!this.mainScenario.aarPressureDressingNotRemoved) {
			this.mainScenario.playSequence('SetBloodParticlePercentage', {
				zeroPercent: false,
				twentyFivePercent: true,
				fiftyPercent: false,
				seventyFivePercent: false,
				oneHundredPercent: false
			});
		}
		this.step2StartTourniqueteRotationInteraction();
	}

	private step1TwistRodNo() {
		var context = this;
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1TwistRod());
	}

	private step2StartTourniqueteRotationInteraction() {
		var context = this;
		setTimeout(() => {
		context.mainScenario.playSequence('VictimPlayLips');
			this.mainScenario.playSound('Step-13', '1', () => {
				this.mainScenario.playSound('Step-13', '2', () => {
					this.mainScenario.playSound('Step-13', '3', () => {
						context.mainScenario.playSequence('VictimStopLips');

					});
				});
			});
		}, 2000);
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Drag the circle within the slider in a clockwise rotation. KB - Tab to circle slider then use the right arrow key.'});
		
		//var numberOfTurns = Tools.randomInteger(3, 4);
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.TourniqueteRotation, {
			dispatch: context.mainScenario.gameManager.customData.dispatch,
			onUpdate: (percentage: number, greenColorPercentage: number) => {
				if(percentage >= greenColorPercentage) {
					setTimeout(() => {
						context.step3HasBleedingStopped();
					}, 500);
				}
			}

});
	}

	private step3HasBleedingStopped() {
		var context = this;

		Globals.stopTimer = true;
		context.mainScenario.stopBleeding();
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Has the bleeding stopped?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps13And14And15.step3HasBleedingStopped', () => context.step3HasBleedingStoppedYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step3HasBleedingStoppedNo()
			}
		});
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.LookAtObject, {
			dispatch: context.mainScenario.gameManager.customData.dispatch,
			TournPivot: true
		});
	}

	private step3HasBleedingStoppedNo() {
		var context = this;
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step3HasBleedingStopped());
	}

	private step3HasBleedingStoppedYes() {
		this.mainScenario.moveToTourniquetLocation();
		this.mainScenario.aarReassessAfterSecondTourniquete = true;
		var context = this;
		context.step4TightenTourniqueteMore();
		this.mainScenario.playSound('Step-14', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');
			this.mainScenario.playSound('Step-14', '2', () => {
				context.mainScenario.playSequence('VictimStopLips');
			});
		});
	}

	private step4TightenTourniqueteMore() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to tighten the tourniquet more?',
			correctButton: {
				title: 'Yes',
				onClick: () => 
				{
					if(context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioC || context.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioD) {
						context.mainScenario.showJITFeedback('This choice is incorrect', () => context.step4TightenTourniqueteMore());
						return;
					}
					context.numberOfTightens++;
					if(context.numberOfTightens > 3) {
						context.mainScenario.showJITFeedback('The tourniquete can not be tightened any further', () => context.step4TightenTourniqueteMore());
					} else {
						context.mainScenario.onAnsweredCorrectly('MainPracticeScenarioSteps13And14And15.step4TightenTourniqueteMore', () => context.step4TightenTourniqueteMoreYes());
					}
				}
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step4TightenTourniqueteMoreNo()
			}
		});
	}

	private step4TightenTourniqueteMoreNo() {
		this.mainScenario.playSequence('TourniquetLock');
		this.step5FinishTourniqueteAnimation();
	}

	private step4TightenTourniqueteMoreYes() {
		this.step2StartTourniqueteRotationInteraction();
	}

	private step5FinishTourniqueteAnimation() {
		var context = this;
		this.mainScenario.gameManager.UiManager.hideaAllUis();
		this.mainScenario.aarRecordTimeOfSecondTourniquete = true;
		this.mainScenario.playSound('Step-15', '1', () => {
			context.mainScenario.playSequence('VictimPlayLips');
			this.mainScenario.playSound('Step-15', '2', () => {
			context.mainScenario.playSequence('VictimStopLips');
			context.onDone();
		});
	});
		// context.mainScenario.playSequence('Steps13And14And15Cinematic', null, () => {
		// 	context.onDone();
		// });
	}
}